import { render } from "./LevelUpModal.vue?vue&type=template&id=eb109fba&scoped=true"
import script from "./LevelUpModal.vue?vue&type=script&lang=js"
export * from "./LevelUpModal.vue?vue&type=script&lang=js"

import "./LevelUpModal.vue?vue&type=style&index=0&id=eb109fba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb109fba"]])

export default __exports__